import React from 'react'
import { COMMENT_CLOSED } from '@BUP/constants'
import modoBupLogo from '../../../assets/Images/ModoBup/modoBupLogo.svg'
import { useTranslation } from 'react-i18next'
import styles from '../userInboxPage/inbox_page.module.scss'
import PageLayout from '@BUP/components/Layout/Page'
import MessagesList from '@BUP/components/ModeBUP/Messages/List'

const BupArchivedPage = () => {
  const [t] = useTranslation('translation', { keyPrefix: 'pages.modeBup' })

  const filterMessages = (messages) => {
    const closedMessages = messages.filter(
      message => message.state === COMMENT_CLOSED
    )
    return closedMessages
  }

  return (
    <PageLayout>
      <div className={styles.inbox_page_container}>
        <div className={styles.inbox_title}>
          <img
            src={modoBupLogo}
            className={styles.image_title}
            alt='logo'
          />
          <h5 className={styles.title_text}>{t('inbox.breadcrumbText2')}</h5>
        </div>
        <div className={styles.messages_list_wrapper}>
          <MessagesList
            title={t('archivedCases.title')}
            titleDark
            filterMessages={filterMessages}
            notifications={[]}
          />
        </div>
      </div>
    </PageLayout>
  )
}

export default BupArchivedPage
